export default __webpack_public_path__ + "static/white-41d46588d32e41a65603f0815f3c69c0.gif";